import React from 'react';
import styles from '../../Advisor.module.css';
import { CheckIcon } from '../../icons';

const FeatureBlocks = () => (
  <>
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />The right people</span>
            <h2>Vetted pros who get small business.</h2>
            <p>Not a call center — real, screened professionals who work with independent businesses every day. Find help with bookkeeping, taxes, cash flow, or planning, matched to what your business actually needs.</p>
            <ul className={styles.fList}>
              {['Bookkeepers, accountants & tax pros', 'Financial and cash-flow guidance', 'Screened and reviewed by other businesses', 'Matched to your industry and stage'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Your matches</div>
              <span className={styles.invLab}>VERIFIED</span>
            </div>
            {[
              ['A. Rivera, CPA', 'Bookkeeping & tax · 4.9★'],
              ['M. Chen', 'Cash flow & planning · 4.8★'],
              ['T. Okafor, EA', 'Tax prep · 5.0★'],
            ].map(([name, meta]) => (
              <div key={name} className={styles.recItem}>
                <span className={`${styles.recDot} ${styles.recDotOn}`} />
                <div className={styles.recFlex}><div className={styles.recName}>{name}</div><div className={styles.recMeta}>{meta}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={`${styles.feature} ${styles.featureFlip}`}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Context built in</span>
            <h2>They already know your numbers.</h2>
            <p>Skip the part where you dig up records and explain your whole setup. With your permission, your advisor can view your Fyntiq income, invoices, and reports — so every conversation starts with the full picture.</p>
            <ul className={styles.fList}>
              {['Share your Fyntiq records in a click', 'You control what they can see', 'Revoke access any time', 'No re-explaining your business'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop}>
              <div><div className={styles.invLab}>ACCESS</div><div className={styles.invNum}>A. Rivera, CPA</div></div>
              <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>You allow</span>
            </div>
            <div className={styles.invRow}><span>Income reports</span><span className={`${styles.mono} ${styles.monoGreen}`}>Shared</span></div>
            <div className={styles.invRow}><span>Invoices</span><span className={`${styles.mono} ${styles.monoGreen}`}>Shared</span></div>
            <div className={styles.invRow}><span>Bank details</span><span className={`${styles.mono} ${styles.monoMuted}`}>Hidden</span></div>
            <div className={styles.invPaynow}>Manage access →</div>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />When you need it</span>
            <h2>Help on your schedule.</h2>
            <p>Book a one-time session before a big decision, or check in regularly through the year. Message between sessions, and keep everything — notes, files, history — in one place.</p>
            <ul className={styles.fList}>
              {['Book one-time or recurring sessions', 'Message your advisor between sessions', 'Notes and files kept together', 'Switch advisors any time'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Upcoming</div>
              <span className={styles.invLab}>THIS WEEK</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>Tax check-in</div><div className={styles.recMeta}>Thu · 2:00 PM</div></div>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>Quarterly review</div><div className={styles.recMeta}>Jun 30</div></div>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOff}`} />
              <div className={styles.recFlex}><div className={styles.recName}>New message</div><div className={styles.recMeta}>From A. Rivera</div></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default FeatureBlocks;
